import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { Institution } from './usePlaidInstitutionById.interface';
import fetchPlaidInstitutionById from './usePlaidInstitutionById.request';

export default function usePlaidInstitutionById(
    institutionId = '',
    options?: Omit<UseQueryOptions<Institution | undefined, unknown, Institution | undefined, string[]>, 'queryKey'>
) {
    return useQuery({
        queryKey: ['plaid', 'usePlaidInstitutionById', institutionId],
        queryFn: () => fetchPlaidInstitutionById(institutionId),
        staleTime: Infinity,
        retry: false,
        refetchOnWindowFocus: false,
        ...options,
    });
}
